import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const ProjectsPage = () => {
  const projects = [
    {
      id: 1,
      name: 'Minik Adımlar Anaokulu',
      location: 'İstanbul',
      image: 'https://public.readdy.ai/ai/img_res/a81c48c8bb602961551c86fefed7f364.jpg',
      description: 'Modern Montessori felsefesiyle tasarlanmış 200m² anaokulu projesi',
    },
    {
      id: 2,
      name: 'Neşeli Çocuklar Oyun Kafesi',
      location: 'Ankara',
      image: 'https://readdy.ai/api/search-image?query=cheerful%20children%20play%20cafe%20interior%20Ankara%20wooden%20play%20structures%20soft%20padded%20seating%20colorful%20wall%20decorations%20families%20enjoying%20space%20natural%20wood%20furniture%20bright%20windows%20happy%20atmosphere%20Montessori%20inspired&width=800&height=450&seq=proj-neseli-001&orientation=landscape',
      description: 'Ebeveyn ve çocuklar için özel tasarlanmış oyun kafesi',
    },
    {
      id: 3,
      name: 'Renkli Dünyam Kreş',
      location: 'İzmir',
      image: 'https://readdy.ai/api/search-image?query=pastel%20colored%20nursery%20creche%20interior%20Izmir%20soft%20wooden%20furniture%20cozy%20reading%20nooks%20natural%20materials%20small%20toddlers%20playing%20sage%20green%20coral%20mint%20pastel%20color%20palette%20Montessori%20design%20warm%20nurturing%20environment&width=800&height=450&seq=proj-renkli-001&orientation=landscape',
      description: 'Pastel renklerle tasarlanmış kreş mobilya projesi',
    },
    {
      id: 4,
      name: 'Küçük Kaşifler Anaokulu',
      location: 'Bursa',
      image: 'https://readdy.ai/api/search-image?query=nature%20explorer%20themed%20kindergarten%20classroom%20Bursa%20Scandinavian%20natural%20birch%20wooden%20furniture%20adventure%20theme%20decorations%20globe%20compass%20map%20decorations%20children%20discovering%20world%20warm%20amber%20light&width=800&height=450&seq=proj-kucukkasif-001&orientation=landscape',
      description: 'Doğal ahşap ve İskandinav tasarım konseptli anaokulu',
    },
    {
      id: 5,
      name: 'Mutlu Çocuklar Merkezi',
      location: 'Antalya',
      image: 'https://readdy.ai/api/search-image?query=children%20activity%20center%20Antalya%20modular%20natural%20birch%20wooden%20furniture%20colorful%20activity%20stations%20safe%20play%20equipment%20children%20engaged%20learning%20stations%20bright%20spacious%20room%20Montessori%20inspired%20design&width=800&height=450&seq=proj-mutlu-001&orientation=landscape',
      description: 'Çocuk aktivite merkezi için özel mobilya tasarımı',
    },
    {
      id: 6,
      name: 'Sevimli Ayılar Anaokulu',
      location: 'Eskişehir',
      image: 'https://readdy.ai/api/search-image?query=cozy%20bear%20themed%20kindergarten%20Eskisehir%20modular%20wooden%20storage%20units%20bear%20animal%20decorations%20plush%20cozy%20reading%20corner%20natural%20birch%20wood%20furniture%20warm%20honey%20amber%20tones%20children%20reading%20playing%20Montessori&width=800&height=450&seq=proj-sevimliayı-001&orientation=landscape',
      description: 'Modüler saklama sistemleri ile donatılmış anaokulu',
    },
  ];

  return (
    <div className="min-h-screen bg-cream">
      <Navbar />

      <section className="pt-32 pb-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center mb-16">
            <p className="text-sm text-warmGray mb-4">PROJELER</p>
            <h1 className="text-5xl md:text-6xl font-display font-bold text-navy mb-6">
              Hayata Geçirdiğimiz Hayal Mekanları
            </h1>
            <p className="text-lg text-warmGray leading-relaxed">
              Türkiye genelinde 150'den fazla anaokulu, oyun kafesi ve çocuk aktivite merkezine mobilya çözümleri sunduk
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {projects.map((project) => (
              <div key={project.id} className="relative h-[450px] rounded-3xl overflow-hidden group cursor-pointer">
                <img
                  src={project.image}
                  alt={project.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <div className="absolute bottom-8 left-8 right-8">
                  <h3 className="text-2xl font-semibold text-white mb-2">{project.name}</h3>
                  <p className="text-white/80 mb-3">{project.location}</p>
                  <p className="text-white/90 text-sm">{project.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ProjectsPage;